module.exports = __webpack_public_path__ + "media/images/app/colors/colors-black-6eac56165d12d0b85546b2e2e9b9bd47.webp";